<template>
  <div>
    <el-upload
      ref="upload"
      class="upload"
      :class="{ small: size === 'small' }"
      drag
      :action="action"
      multiple
      :on-success="handleSuccess"
      :show-file-list="false"
      :limit="limit"
      :on-exceed="handleExceed"
      :before-upload="defaultBeforeUpload"
      :on-error="handleError"
    >
      <div class="content">
        <div class="center">
          <img :src="uploadIcon" /><span class="label">点击上传</span>
        </div>
      </div>
    </el-upload>
    <div class="ml-80">
      <el-tag
        v-for="(item, index) in fileList"
        :key="index"
        class="fileTag"
        :title="item.name"
        closable
        @close="onRemoveIndustryFile(index)"
      >
        <span @click="showUrl(item)" v-if="item.name && item.name.length >= 20"
          >{{ item.name.substring(0, 20) }}...</span
        >
        <span @click="showUrl(item)" v-else>
          {{ item.name }}
        </span>
      </el-tag>
    </div>
  </div>
</template>

<script>
import uploadIcon from '@/assets/img/ecology/upload_icon.png'

export default {
  props: {
    size: {
      type: String,
      default: ''
    },
    limit: {
      type: Number,
      default: 5
    },
    list: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      uploadIcon,
      fileList: [],
      action: window.SITE_CONFIG['apiURL'] + '/front/fileupload/alioss/upload'
    }
  },
  created () {
    console.log(this.list)
    if (this.list.length > 0) {
      this.fileList = this.list.map((v) => {
        return {
          ...v,
          name: v.fileName,
          response: {
            data: {
              ...v,
              aliOssId: v.ossId
            }
          }
        }
      })
      this.$emit('success', this.fileList)
    }
  },
  methods: {
    onRemoveIndustryFile (index) {
      this.fileList.splice(index, 1)
      this.$emit('success', this.fileList)
    },
    handleError (...res) {
      console.log(res)
    },
    handleSuccess (res, file, fileList) {
      //   console.log(res, file, fileList)
      this.fileList = fileList
      if (res.code === 0) {
        this.$emit('success', fileList)
      } else {
        this.$message.error(res.msg)
      }
    },
    defaultBeforeUpload (file) {
      console.log('defaultBeforeUpload')
      // 上传前校验
      const isLt2M = file.size / 1024 / 1024 < 100
      if (!isLt2M) {
        this.$message.error('上传的附件不得大于100MB')
        return false
      }
      return true
    },
    showUrl (item) {
      console.log(item)
      if (item.response) {
        window.open(item.response.data.url)
      }
    },
    // 文件超过限制提示
    handleExceed (files, fileList) {
      this.$message.warning(
        `当前限制选择 ${this.limit} 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.small {
  ::v-deep .el-upload-dragger {
    height: 40px !important;
  }
}

.upload {
  ::v-deep .el-upload-dragger {
    width: 200px;
    height: 80px;
  }

  .content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
  }

  .center {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 20px;
  }

  .label {
    font-size: 14px;
    font-weight: 600;
    text-align: center;
    color: #333333;
    margin-left: 8px;
  }

  .tip {
    font-size: 12px;
    text-align: center;
    color: #999999;
    height: 20px;
  }
}

.fileTag {
  display: inline-block;
  margin-right: 8px;
  color: #2a54d1;
  background-color: #f1f5fb;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
